import Se, { createContext as G, useContext as q, useState as Fe, useCallback as A, useLayoutEffect as Oe, useEffect as ne, useMemo as Ve, useReducer as Te } from "react";
import Me from "md5";
import Ye from "pusher-js";
const Ae = G(() => {
  console.warn("activity monitor context is not ready");
}), ot = () => q(Ae);
var _e, re = { exports: {} }, F = {}, ge, Ee, be = {};
function ze() {
  return ge || (ge = 1, t = be, process.env.NODE_ENV !== "production" && function() {
    var n = Se, o = 60103, p = 60106;
    t.Fragment = 60107;
    var r = 60108, c = 60114, _ = 60109, d = 60110, l = 60112, h = 60113, i = 60120, T = 60115, v = 60116, E = 60121, L = 60122, oe = 60117, ae = 60129, ie = 60131;
    if (typeof Symbol == "function" && Symbol.for) {
      var P = Symbol.for;
      o = P("react.element"), p = P("react.portal"), t.Fragment = P("react.fragment"), r = P("react.strict_mode"), c = P("react.profiler"), _ = P("react.provider"), d = P("react.context"), l = P("react.forward_ref"), h = P("react.suspense"), i = P("react.suspense_list"), T = P("react.memo"), v = P("react.lazy"), E = P("react.block"), L = P("react.server.block"), oe = P("react.fundamental"), P("react.scope"), P("react.opaque.id"), ae = P("react.debug_trace_mode"), P("react.offscreen"), ie = P("react.legacy_hidden");
    }
    var se = typeof Symbol == "function" && Symbol.iterator, V = n.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function I(e) {
      for (var u = arguments.length, s = new Array(u > 1 ? u - 1 : 0), R = 1; R < u; R++) s[R - 1] = arguments[R];
      (function(g, y, m) {
        var b = V.ReactDebugCurrentFrame, S = "";
        if (D) {
          var C = k(D.type), w = D._owner;
          S += function(a, O, x) {
            var N = "";
            if (O) {
              var Y = O.fileName, H = Y.replace(X, "");
              if (/^index\./.test(H)) {
                var U = Y.match(X);
                if (U) {
                  var he = U[1];
                  he && (H = he.replace(X, "") + "/" + H);
                }
              }
              N = " (at " + H + ":" + O.lineNumber + ")";
            } else x && (N = " (created by " + x + ")");
            return `
    in ` + (a || "Unknown") + N;
          }(C, D._source, w && k(w.type));
        }
        (S += b.getStackAddendum()) !== "" && (y += "%s", m = m.concat([S]));
        var f = m.map(function(a) {
          return "" + a;
        });
        f.unshift("Warning: " + y), Function.prototype.apply.call(console[g], console, f);
      })("error", e, s);
    }
    var X = /^(.*)[\\\/]/, Ue = 1;
    function k(e) {
      if (e == null) return null;
      if (typeof e.tag == "number" && I("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue."), typeof e == "function") return e.displayName || e.name || null;
      if (typeof e == "string") return e;
      switch (e) {
        case t.Fragment:
          return "Fragment";
        case p:
          return "Portal";
        case c:
          return "Profiler";
        case r:
          return "StrictMode";
        case h:
          return "Suspense";
        case i:
          return "SuspenseList";
      }
      if (typeof e == "object") switch (e.$$typeof) {
        case d:
          return "Context.Consumer";
        case _:
          return "Context.Provider";
        case l:
          return R = e, g = e.render, y = "ForwardRef", m = g.displayName || g.name || "", R.displayName || (m !== "" ? y + "(" + m + ")" : y);
        case T:
          return k(e.type);
        case E:
          return k(e.render);
        case v:
          var u = (s = e)._status === Ue ? s._result : null;
          if (u) return k(u);
      }
      var s, R, g, y, m;
      return null;
    }
    var ce = {};
    V.ReactDebugCurrentFrame;
    var D = null;
    function M(e) {
      D = e;
    }
    var le, ue, fe = V.ReactCurrentOwner, Z = Object.prototype.hasOwnProperty, je = { key: !0, ref: !0, __self: !0, __source: !0 };
    function xe(e, u, s, R, g) {
      var y, m = {}, b = null, S = null;
      for (y in s !== void 0 && (b = "" + s), function(f) {
        if (Z.call(f, "key")) {
          var a = Object.getOwnPropertyDescriptor(f, "key").get;
          if (a && a.isReactWarning) return !1;
        }
        return f.key !== void 0;
      }(u) && (b = "" + u.key), function(f) {
        if (Z.call(f, "ref")) {
          var a = Object.getOwnPropertyDescriptor(f, "ref").get;
          if (a && a.isReactWarning) return !1;
        }
        return f.ref !== void 0;
      }(u) && (S = u.ref, function(f) {
        typeof f.ref == "string" && fe.current;
      }(u)), u) Z.call(u, y) && !je.hasOwnProperty(y) && (m[y] = u[y]);
      if (e && e.defaultProps) {
        var C = e.defaultProps;
        for (y in C) m[y] === void 0 && (m[y] = C[y]);
      }
      if (b || S) {
        var w = typeof e == "function" ? e.displayName || e.name || "Unknown" : e;
        b && function(f, a) {
          var O = function() {
            le || (le = !0, I("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", a));
          };
          O.isReactWarning = !0, Object.defineProperty(f, "key", { get: O, configurable: !0 });
        }(m, w), S && function(f, a) {
          var O = function() {
            ue || (ue = !0, I("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", a));
          };
          O.isReactWarning = !0, Object.defineProperty(f, "ref", { get: O, configurable: !0 });
        }(m, w);
      }
      return function(f, a, O, x, N, Y, H) {
        var U = { $$typeof: o, type: f, key: a, ref: O, props: H, _owner: Y, _store: {} };
        return Object.defineProperty(U._store, "validated", { configurable: !1, enumerable: !1, writable: !0, value: !1 }), Object.defineProperty(U, "_self", { configurable: !1, enumerable: !1, writable: !1, value: x }), Object.defineProperty(U, "_source", { configurable: !1, enumerable: !1, writable: !1, value: N }), Object.freeze && (Object.freeze(U.props), Object.freeze(U)), U;
      }(e, b, S, g, R, fe.current, m);
    }
    var Q, ee = V.ReactCurrentOwner;
    function $(e) {
      D = e;
    }
    function te(e) {
      return typeof e == "object" && e !== null && e.$$typeof === o;
    }
    function pe() {
      if (ee.current) {
        var e = k(ee.current.type);
        if (e) return `

Check the render method of \`` + e + "`.";
      }
      return "";
    }
    V.ReactDebugCurrentFrame, Q = !1;
    var de = {};
    function ye(e, u) {
      if (e._store && !e._store.validated && e.key == null) {
        e._store.validated = !0;
        var s = function(g) {
          var y = pe();
          if (!y) {
            var m = typeof g == "string" ? g : g.displayName || g.name;
            m && (y = `

Check the top-level render call using <` + m + ">.");
          }
          return y;
        }(u);
        if (!de[s]) {
          de[s] = !0;
          var R = "";
          e && e._owner && e._owner !== ee.current && (R = " It was passed a child from " + k(e._owner.type) + "."), $(e), I('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', s, R), $(null);
        }
      }
    }
    function ve(e, u) {
      if (typeof e == "object") {
        if (Array.isArray(e)) for (var s = 0; s < e.length; s++) {
          var R = e[s];
          te(R) && ye(R, u);
        }
        else if (te(e)) e._store && (e._store.validated = !0);
        else if (e) {
          var g = function(b) {
            if (b === null || typeof b != "object") return null;
            var S = se && b[se] || b["@@iterator"];
            return typeof S == "function" ? S : null;
          }(e);
          if (typeof g == "function" && g !== e.entries) for (var y, m = g.call(e); !(y = m.next()).done; ) te(y.value) && ye(y.value, u);
        }
      }
    }
    function De(e) {
      var u, s = e.type;
      if (s != null && typeof s != "string") {
        if (typeof s == "function") u = s.propTypes;
        else {
          if (typeof s != "object" || s.$$typeof !== l && s.$$typeof !== T) return;
          u = s.propTypes;
        }
        if (u) {
          var R = k(s);
          (function(g, y, m, b, S) {
            var C = Function.call.bind(Object.prototype.hasOwnProperty);
            for (var w in g) if (C(g, w)) {
              var f = void 0;
              try {
                if (typeof g[w] != "function") {
                  var a = Error((b || "React class") + ": " + m + " type `" + w + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof g[w] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  throw a.name = "Invariant Violation", a;
                }
                f = g[w](y, w, b, m, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (O) {
                f = O;
              }
              !f || f instanceof Error || (M(S), I("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", b || "React class", m, w, typeof f), M(null)), f instanceof Error && !(f.message in ce) && (ce[f.message] = !0, M(S), I("Failed %s type: %s", m, f.message), M(null));
            }
          })(u, e.props, "prop", R, e);
        } else s.PropTypes === void 0 || Q || (Q = !0, I("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", k(s) || "Unknown"));
        typeof s.getDefaultProps != "function" || s.getDefaultProps.isReactClassApproved || I("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function me(e, u, s, R, g, y) {
      var m = function(a) {
        return typeof a == "string" || typeof a == "function" || a === t.Fragment || a === c || a === ae || a === r || a === h || a === i || a === ie || typeof a == "object" && a !== null && (a.$$typeof === v || a.$$typeof === T || a.$$typeof === _ || a.$$typeof === d || a.$$typeof === l || a.$$typeof === oe || a.$$typeof === E || a[0] === L);
      }(e);
      if (!m) {
        var b, S = "";
        (e === void 0 || typeof e == "object" && e !== null && Object.keys(e).length === 0) && (S += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports."), S += pe(), e === null ? b = "null" : Array.isArray(e) ? b = "array" : e !== void 0 && e.$$typeof === o ? (b = "<" + (k(e.type) || "Unknown") + " />", S = " Did you accidentally export a JSX literal instead of a component?") : b = typeof e, I("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", b, S);
      }
      var C = xe(e, u, s, g, y);
      if (C == null) return C;
      if (m) {
        var w = u.children;
        if (w !== void 0) if (R) if (Array.isArray(w)) {
          for (var f = 0; f < w.length; f++) ve(w[f], e);
          Object.freeze && Object.freeze(w);
        } else I("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
        else ve(w, e);
      }
      return e === t.Fragment ? function(a) {
        for (var O = Object.keys(a.props), x = 0; x < O.length; x++) {
          var N = O[x];
          if (N !== "children" && N !== "key") {
            $(a), I("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", N), $(null);
            break;
          }
        }
        a.ref !== null && ($(a), I("Invalid attribute `ref` supplied to `React.Fragment`."), $(null));
      }(C) : De(C), C;
    }
    var $e = function(e, u, s) {
      return me(e, u, s, !1);
    }, He = function(e, u, s) {
      return me(e, u, s, !0);
    };
    t.jsx = $e, t.jsxs = He;
  }()), be;
  var t;
}
var B = (Ee || (Ee = 1, process.env.NODE_ENV === "production" ? re.exports = function() {
  if (_e) return F;
  _e = 1;
  var t = Se, n = 60103;
  if (F.Fragment = 60107, typeof Symbol == "function" && Symbol.for) {
    var o = Symbol.for;
    n = o("react.element"), F.Fragment = o("react.fragment");
  }
  var p = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, r = Object.prototype.hasOwnProperty, c = { key: !0, ref: !0, __self: !0, __source: !0 };
  function _(d, l, h) {
    var i, T = {}, v = null, E = null;
    for (i in h !== void 0 && (v = "" + h), l.key !== void 0 && (v = "" + l.key), l.ref !== void 0 && (E = l.ref), l) r.call(l, i) && !c.hasOwnProperty(i) && (T[i] = l[i]);
    if (d && d.defaultProps) for (i in l = d.defaultProps) T[i] === void 0 && (T[i] = l[i]);
    return { $$typeof: n, type: d, key: v, ref: E, props: T, _owner: p.current };
  }
  return F.jsx = _, F.jsxs = _, F;
}() : re.exports = ze()), re.exports);
const Ie = G(void 0), at = () => q(Ie), Ce = ({ key: t, defaultValue: n, onExternalUpdate: o }) => {
  const [p, r] = Fe(), c = A(() => {
    if (t) try {
      const h = window.localStorage.getItem(t);
      if (!h) return void r(n);
      const i = JSON.parse(h);
      return r(i), i;
    } catch (h) {
      return void console.error(`Error reading local storage item ${t}:`, h);
    }
  }, [n, t]), _ = A((h) => {
    if (t) try {
      const i = JSON.stringify(h);
      window.localStorage.setItem(t, i), r(h), window.dispatchEvent(new StorageEvent("local-storage", { key: t, newValue: i }));
    } catch (i) {
      console.error(`Error setting local storage item ${t}:`, i);
    }
  }, [t]), d = A(() => {
    t && (window.localStorage.removeItem(t), new StorageEvent("local-storage", { key: t, url: window.location.origin }));
  }, [t]), l = A((h) => {
    o && h.key === t && (console.log(JSON.stringify(h, null, 2)), o(c()));
  }, [t, c, o]);
  return Oe(() => {
    c();
  }, [c]), ne(() => (window.addEventListener("local-storage", l), window.addEventListener("storage", l), () => {
    window.removeEventListener("local-storage", l), window.removeEventListener("storage", l);
  }), [l]), [p, _, d];
}, K = (t, n) => {
  let o, p = t;
  try {
    let r = n.split(".");
    for (r.length === 0 && (r = [n]); r.length > 0; ) {
      if (o = r.shift(), !o) return;
      if (Array.isArray(p[o])) {
        p = [];
        const c = r.splice(-1).join(".");
        for (let _ = 0, d = t[o].length; _ < d; _++) p.push(K(t[o][_], c));
      } else p = p[o];
    }
    return p;
  } catch (r) {
    return void console.error("unexpected error occurred while trying to find value from pointer", t, n, r);
  }
}, J = (t, n, o) => {
  let p, r = -1;
  for (let c = 0, _ = t?.length; c < _; c += 1) if (p = K(t[c], n), Array.isArray(p)) {
    if (p.indexOf(o) !== -1) {
      r = c;
      break;
    }
  } else if (p === o) {
    r = c;
    break;
  }
  return r;
}, Pe = (t, n) => [...t].sort((o, p) => {
  let r = K(o, n.toString()), c = K(p, n.toString());
  return typeof r == "string" && (r = r.toLocaleLowerCase()), typeof c == "string" && (c = c.toLocaleLowerCase()), r === c ? 0 : r < c ? -1 : 1;
}), it = ({ partitionKey: t, activityKinds: n, children: o }) => {
  const p = Ve(() => n.reduce((d, l) => (d[l.kind] = [], d), { all: [] }), [n]), [r, c] = Ce({ key: t, defaultValue: p }), _ = A((d) => {
    if (!r) return void console.warn("unable to add activity: monitor not initialized");
    const l = d.kind;
    if (!(l in r)) return void console.warn(`unable to add activity: unsupported kind: ${d.kind}`, d);
    if (!d.entity.id) return void console.warn("unable to add activity: entity does not have an ID", d);
    const h = (/* @__PURE__ */ new Date()).toJSON();
    let i, T;
    switch (l) {
      case "project":
      case "scenario-interactive":
      case "scenario-rule":
        i = r[l], T = { ...d, visited_at: h };
    }
    const v = J(r[d.kind], "entity.id", d.entity.id);
    if (v === -1) i.unshift(T), i.length = Math.min(i.length, 10);
    else switch (i[v].visited_at = h, Pe(i, "visited_at"), l) {
      case "project":
      case "scenario-interactive":
      case "scenario-rule":
        r[l] = i.reverse();
    }
    const E = J(r.all, "entity.id", d.entity.id);
    E === -1 ? (r.all.unshift(T), r.all.length = Math.min(r.all.length, 10)) : (r.all[E].visited_at = h, Pe(r.all, "visited_at"), r.all = r.all.reverse()), c(r);
  }, [r, c]);
  return B.jsx(Ie.Provider, { value: r, children: B.jsx(Ae.Provider, { value: _, children: o }) });
}, st = { ALL: "all", PROJECT: "project", SCENARIO_INTERACTIVE: "scenario-interactive", SCENARIO_RULE: "scenario-rule" }, We = "PUSHER_SET_CONTROLLER", Be = (t, n) => ({ ...t, _controller: n }), Ke = "PUSHER_SET_USER_CHANNEL", Je = (t, n) => ({ ...t, userChannel: n }), Ge = (t, n) => {
  switch (n.type) {
    case We:
      return Be(t, n.data);
    case Ke:
      return Je(t, n.data);
  }
}, z = () => {
  console.warn("pusher context is not ready");
}, Le = { _controller: void 0, userChannel: void 0, initPusher: z, subscribeToPush: z, unsubscribeFromPush: z, shutdownPusher: z }, ke = G(Le), ct = () => q(ke), lt = ({ children: t }) => {
  const n = { ENV: "prod", HIVEMIND_ENV: "platform.hivery.ai", CY_TEST: "false", JEST: !1, ALLOW_PASSWORD_LOGIN: "true", CURATE_API_V1: "https://platform.hivery.ai/api/v1/curate", CURATE_API_V2: "https://platform.hivery.ai/api/v2/curate", INTERACTIVE_EDIT_API: "https://platform.hivery.ai/api/v1/ie", PREDICTION_API: "https://platform.hivery.ai/api/v1/prediction", SSDI_API: "https://platform.hivery.ai/api/v1/ssdi", SSDI_API_V2: "https://platform.hivery.ai/api/v2/ssdi", STRATEGY_API: "https://platform.hivery.ai/api/v1/strategies", AGENT_API: "https://platform.hivery.ai/api/v1/agent", FILES_API_HOST: "", AUTH0_CLIENT_ID: "lTmZNPup2RLBspGNwIHil5twcTJ0hmtr", AUTH0_DOMAIN: "auth.platform.hivery.ai", AUTH0_AUDIENCE: "propel-api-prod", PUSHER_APP_KEY: "b1bba340abf50d80e589", PUSHER_CLUSTER: "us3", PUSHER_IE_APP_KEY: "b1bba340abf50d80e589", PUSHER_IE_CLUSTER: "us3", UNLEASH_URL: "https://zero.hivery.ai/unleash/api/frontend", UNLEASH_TOKEN: "*:production.c4df01408a23f527f64ab1dd71c1c692038dce56783d8f738b589208", UNLEASH_ENV: "production", OTEL_KEY: "46349299-7ec4-41d9-a0b5-1912980d56ba", OTEL_EXPORT_URL: "https://ingest.us.signoz.cloud:443", OTEL_SERVICE_NAME: "honeycomb", PRODUCT_IMAGE_HOST: "prd", AZURE_CDN_DOMAIN: "https://app.curate.hivery.ai" }, [o, p] = Te(Ge, { ...Le }), r = A((v) => {
    c({ type: "PUSHER_SET_CONTROLLER", data: v });
  }, [c = p]);
  var c;
  const _ = ((v) => A((E) => {
    v({ type: "PUSHER_SET_USER_CHANNEL", data: E });
  }, [v]))(p), d = A((v, E) => {
    const L = new Ye(n.PUSHER_APP_KEY, { authEndpoint: `${n.CURATE_API_V1}/pusher/authenticate`, auth: { headers: { Authorization: `Bearer ${v}` } }, cluster: n.PUSHER_CLUSTER, forceTLS: !0 });
    r(L), _(L.subscribe(`private-user-${Me(E)}`));
  }, [n.CURATE_API_V1, n.PUSHER_APP_KEY, n.PUSHER_CLUSTER, r, _]), l = A((v) => {
    if (!o._controller) return void console.warn("unable to subscribe to notifications: service not ready.");
    const E = o._controller.allChannels();
    if (!E) return o._controller.subscribe(v);
    const L = J(E, "name", v);
    return L === -1 ? o._controller.subscribe(v) : E[L];
  }, [o._controller]), h = A((v) => {
    if (!o._controller) return void console.warn("unable to unsubscribe to notifications: service not ready.");
    const E = o._controller.allChannels();
    E && (J(E, "name", v) !== -1 ? o._controller.unsubscribe(v) : console.warn("unable to unsubscribe: channel was not found", v));
  }, [o._controller]), i = A(() => {
    if (!o._controller) return void console.warn("unable to shutdown notifications: service not ready.");
    const v = o._controller, E = o._controller.allChannels();
    E && E.forEach((L) => {
      v.unsubscribe(L.name);
    });
  }, [o._controller]), T = { ...o, initPusher: d, subscribeToPush: l, unsubscribeFromPush: h, shutdownPusher: i };
  return B.jsx(ke.Provider, { value: T, children: t });
}, qe = "THEME_SET_MODE", Xe = (t, n) => ({ ...t, mode: n }), Ze = (t, n) => {
  if (n.type === qe) return Xe(t, n.data);
}, W = { mode: "light", setMode: () => {
  console.warn("theme context is not ready");
} }, Ne = G(W), ut = () => q(Ne), ft = ({ children: t, disabled: n = !0 }) => {
  const [o, p] = Te(Ze, { ...W, mode: W.mode }), r = A((i) => {
    c({ type: "THEME_SET_MODE", data: i });
  }, [c = p]);
  var c;
  const [_, d] = Ce({ key: "themeMode", defaultValue: W.mode, onExternalUpdate: r }), l = A((i) => {
    document.body.dataset.theme = i, d(i), r(i);
  }, [r, d]), h = { ...o, setMode: l };
  return ne(() => {
    if (n) return document.body.dataset.theme = "", void document.body.classList.remove("bg-surface", "text-on-surface");
    _ !== o.mode && (document.body.classList.add("bg-surface", "text-on-surface"), document.body.dataset.theme = _, r(_));
  }, [n, r, _, o.mode]), Oe(() => {
    if (n) return document.body.dataset.theme = "", void document.body.classList.remove("bg-surface", "text-on-surface");
    document.body.classList.add("bg-surface", "text-on-surface"), document.body.dataset.theme = o.mode;
  }, [n, o.mode]), B.jsx(Ne.Provider, { value: h, children: t });
}, j = [], pt = (t) => {
  const n = t.navigate.bind(t);
  t.navigate = async (...o) => {
    const p = o;
    if (j.length > 0) {
      const r = j.map((c) => c());
      if (!(await Promise.all(r)).every(Boolean)) return;
    }
    return n(...p);
  }, t.subscribe(async (o) => {
    if (o.historyAction === "POP" && j.length > 0) {
      const p = j.map((r) => r());
      (await Promise.all(p)).every(Boolean) || n(1);
    }
  });
}, we = (t) => {
  t.preventDefault(), t.returnValue = "";
}, Re = (t) => {
  t.preventDefault(), t.stopImmediatePropagation(), t.stopPropagation();
}, Qe = (t) => (j.length === 0 && (addEventListener("beforeunload", we, { capture: !0 }), addEventListener("popstate", Re, { capture: !0 })), j.push(t), () => {
  const n = j.indexOf(t);
  j.splice(n, 1), j.length === 0 && (removeEventListener("beforeunload", we, { capture: !0 }), removeEventListener("popstate", Re, { capture: !0 }));
}), et = (t, n) => {
  ne(() => {
    if (t) return Qe(n);
  }, [n, t]);
}, dt = (t, n = !1) => {
  et(n, A(() => confirm(t), [t]));
};
export {
  st as ACTIVITY_KINDS,
  it as ActivityMonitorProvider,
  ke as PusherContext,
  lt as PusherProvider,
  ft as ThemeProvider,
  Qe as blockNavigation,
  pt as createRouterObservers,
  ot as useActivityMonitorActions,
  at as useActivityMonitorState,
  et as useBlocker,
  Ce as useLocalStorage,
  dt as usePrompt,
  ct as usePusherContext,
  ut as useThemeContext
};
//# sourceMappingURL=mystique.js.map
